import Glide from '@glidejs/glide';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Simple domReady helper function
function domReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
  /**
   * toggleClasses()
   *
   * @description
   * toggle specific classes based on data-attr of clicked element
   *
   * @requires
   * 'js-toggle' class and a data-attr with the element to be
   * toggled's class name both applied to the clicked element
   *
   * @example
   * <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
   * <div class="toggled-class">This element's class will be toggled</div>
   *
   * @param {Element} element - element to toggle.
   */
  function toggleClasses(element) {
    const togglePrefix = element.dataset.prefix || 'this';
    let toggled = null;

    // If the element you need toggled is relative to the toggle, add the
    // .js-this class to the parent element and "this" to the data-toggled attr.
    if (element.dataset.toggled == "this") {
      toggled = [...element.closest('.js-this')];
    }
    else {
      toggled = [...document.querySelectorAll(element.dataset.toggled)];
    }
    if (element.getAttribute('aria-expanded') == 'true') {
      element.setAttribute('aria-expanded', 'true');
    }
    else {
      element.setAttribute('aria-expanded', 'false');
    }
    element.classList.toggle(togglePrefix + '-is-active');

    if (toggled && toggled.length) {
      toggled.forEach((el) => {
        el.classList.toggle(togglePrefix + '-is-active');
      })
    }

    // Remove a class on another element, if needed.
    if (element.dataset.removeClass) {
      document.querySelector('.' + element.dataset.removeClass).classList.remove(element.dataset.removeClass);
    }
  }

  function setUtilities(parentEl) {
    // Toggle class
    [...parentEl.querySelectorAll('.js-toggle:not(.js-toggle--initialized)')].forEach((el) => {
      el.classList.add('js-toggle--initialized');
      el.addEventListener('click', (e) => {
        if (!el.classList.contains('js-not-stop')) {
          e.preventDefault();
          e.stopPropagation();
        }
        toggleClasses(el);
      });
    });

    // Toggle parent class
    [...parentEl.querySelectorAll('.js-toggle-parent:not(.js-toggle-parent--initialized)')].forEach((el) => {
      el.classList.add('js-toggle-parent--initialized');
      el.addEventListener('click', (e) => {
        if (!el.classList.contains('js-not-stop')) {
          e.preventDefault();
        }
        el.classList.toggle('this-is-active');
        el.parentElement.classList.toggle('this-is-active');
      });
    });
  }

  setUtilities(document);


  // const phrases = ['Experts & Innovators', 'Authors & Advocates', 'Practitioners & Scholars', 'Creators & Protectors', 'Professionals & Visionaries'];
  // const phraseElement = document.getElementById('phrase');

  // function animatePhrases() {
  //   const tl = gsap.timeline({ repeat: -1 }); // Create a repeating timeline

  //   phrases.forEach((phrase) => {
  //     tl.to(phraseElement, {
  //       opacity: 0,
  //       duration: 1,
  //       onStart: () => {
  //         phraseElement.classList.remove('text-active');
  //       },
  //       onComplete: () => {
  //         phraseElement.textContent = phrase;
  //       },
  //     })
  //     .to(phraseElement, {
  //       opacity: 1,
  //       duration: 1,
  //       onStart: () => {
  //         phraseElement.classList.add('text-active');
  //       },
  //       onComplete: () => {
  //         phraseElement.textContent = phrase;
  //       },
  //     })
  //     .to(phraseElement, {
  //       duration: 2, // This creates the 2-second pause
  //       onComplete: () => {
  //         phraseElement.classList.add('text-active');
  //         phraseElement.textContent = phrase;
  //       },
  //     });
  //   });
  // }

  // // Start the animation
  // phraseElement.textContent = phrases[0]; // Set initial text
  // phraseElement.classList.add('text-active');

  // animatePhrases();


  const JournalVolumeNavSlider = document.querySelectorAll('.c-journal-volume-nav__carousel');
  if (JournalVolumeNavSlider.length > 0) {
    JournalVolumeNavSlider.forEach((slider) => {
      const JournalVolumeNavSlider = new Glide(slider, {
        type: 'slider',
        startAt: 0,
        perView: 4,
        gap: 32,
        animationDuration: 1000,
        breakpoints: {
          768: {
            perView: 3,
          },
          480: {
            perView: 2,
            gap: 8,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      });
      JournalVolumeNavSlider.mount();
    });
  }


  const gridHorizontal3upSlider = document.querySelectorAll('.c-grid--horizontal-carousel-3up');
  if (gridHorizontal3upSlider.length > 0) {
    gridHorizontal3upSlider.forEach((slider) => {
      const glideHorizontal3upSlider = new Glide(slider, {
        type: 'slider',
        startAt: 0,
        perView: 3,
        gap: 32,
        animationDuration: 1000,
        breakpoints: {
          768: {
            perView: 2,
          },
          480: {
            perView: 1,
            gap: 8,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      });
      glideHorizontal3upSlider.mount();
    });
  }

  const gridHorizontal4upSlider = document.querySelectorAll('.c-grid--horizontal-carousel-4up');
  if (gridHorizontal4upSlider.length > 0) {
    gridHorizontal4upSlider.forEach((slider) => {
      const glideHorizontal4upSlider = new Glide(slider, {
        type: 'slider',
        startAt: 0,
        perView: 4,
        gap: 32,
        animationDuration: 1000,
        breakpoints: {
          768: {
            perView: 2,
          },
          480: {
            perView: 1,
            gap: 8,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      });
      glideHorizontal4upSlider.mount();
    });
  }

  if(document.getElementsByClassName('glide').length > 0) {
    const startAtVar = 0
    
    const glide = new Glide('.glide', {
      type: 'carousel',
      startAt: startAtVar,
      perView: 1,
    }).mount()
  
    const activeSlideCount = document.querySelector('.c-hero__carousel--active')
    activeSlideCount.innerText = `0${startAtVar+1}`.slice(-2)
 
    glide.on('run.after', function() {
      activeSlideCount.innerText = `0${glide.index+1}`.slice(-2);
    });
  
  }


  if(document.getElementsByClassName('image-gallery-glide').length > 0) {
    new Glide('.image-gallery-glide', {
      type: 'carousel',
      perView: 4,
      gap: 32,
    }).mount()
  }
};

domReady(async () => {
  /**
   * GSAP animations
   */
  gsap.registerPlugin(ScrollTrigger);

  /**
   * Function to split words and apply GSAP animation
   * 1. Set initial opacity to make the element visible
   * 2. Split the text content into words and spaces
   * 3. Store wordDivs to animate later
   * 4. Loop through each word or space
   * 5. Create divs for words and spaces to apply animation
   * 6. Preserve spaces in the content
   */
  function splitWords(targetElement) {
    targetElement.style.opacity = 1; /* 1 */
    const wordsAndSpaces = targetElement.textContent.trim().match(/(\S+|\s+)/g); /* 2 */
    targetElement.innerHTML = '';
    const wordDivs = []; /* 3 */
    /* 4 */
    wordsAndSpaces.forEach((item) => {
      if (item.trim()) {
        /* 5 */
        const maskDiv = document.createElement('div');
        maskDiv.classList.add('o-mask');
        const wordDiv = document.createElement('div');
        wordDiv.textContent = item;
        maskDiv.appendChild(wordDiv);
        targetElement.appendChild(maskDiv);
        wordDivs.push(wordDiv);
      } else {
        /* 6 */
        targetElement.appendChild(document.createTextNode(item));
      }
    });

    /**
     * Trigger the GSAP animation on the created elements
     */
    gsap.fromTo(wordDivs,
      {
        y: 300,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        delay: 0.1,
        stagger: 0.05,
        duration: 1,
        ease: "Quint.easeOut",
      }
    );
  }

  /**
   * Query all section containers to initialize animations for each one
   */
  const triggers = document.querySelectorAll('section, .js-gsap-trigger');
  if (triggers) {
    triggers.forEach((trigger) => {

      /**
       * Split words fade up animation
       */
      const gsapSplitWords = trigger.querySelectorAll(".js-gsap-split-words");
      if (gsapSplitWords) {
        gsapSplitWords.forEach((element) => {
          gsap.to(element, {
            ease: "Quint.easeOut",
            scrollTrigger: {
              trigger: element,
              start: "top bottom",
              onEnter: () => splitWords(element),
            },
          });
        });
      }

      /**
       * Slide in up animation
       */
      const gsapSlideInUp = trigger.querySelectorAll(".js-gsap-slide-in-up");
      if (gsapSlideInUp) {
        gsapSlideInUp.forEach((element, index) => {
          gsap.fromTo(
            element,
            {
              y: 80,
              opacity: 0,
            },
            {
              y: 0,
              opacity: 1,
              duration: 0.8,
              ease: "power1.in",
              scrollTrigger: element,
              delay: index * 0.1, // Adjust the delay for stagger effect
            }
          );
        });
      }

      /**
       * Background image animation
       */
      const gsapBackgroundImage = trigger.querySelectorAll(".js-gsap-background-image");
      if (gsapBackgroundImage) {
        gsapBackgroundImage.forEach((element) => {
          gsap.to(element, {
            backgroundPosition: `50% ${innerHeight / 4}`,
            ease: "none",
            scrollTrigger: {
              trigger: element,
              scrub: true,
            },
          });
        });
      }

      /**
       * Slide in left animation
       */
      const gsapSlideInLeft = trigger.querySelectorAll(".js-gsap-slide-in-left");
      if (gsapSlideInLeft) {
        gsapSlideInLeft.forEach((element, index) => {
          gsap.fromTo(
            element,
            {
              x: -80,
              opacity: 0,
            },
            {
              x: 0,
              opacity: 1,
              duration: 0.8,
              ease: "power1.in",
              scrollTrigger: element,
              delay: index * 0.1, // Adjust the delay for stagger effect
            }
          );
        });
      }

      /**
       * Slide in right animation
       */
      const gsapSlideInRight = trigger.querySelectorAll(".js-gsap-slide-in-right");
      if (gsapSlideInRight) {
        gsapSlideInRight.forEach((element, index) => {
          gsap.fromTo(
            element,
            {
              x: 80,
              opacity: 0,
            },
            {
              x: 0,
              opacity: 1,
              duration: 0.8,
              ease: "power1.in",
              scrollTrigger: element,
              delay: index * 0.1, // Adjust the delay for stagger effect
            }
          );
        });
      }

      /**
       * Fade in animation
       */
      const gsapFadeIn = trigger.querySelectorAll(".js-gsap-fade-in");
      if (gsapFadeIn) {
        gsapFadeIn.forEach((element, index) => {
          gsap.fromTo(
            element,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              duration: 0.8,
              ease: "power1.in",
              scrollTrigger: element,
              delay: index * 0.1, // Adjust the delay for stagger effect
            }
          );
        });
      }

      /**
       * Scale in animation
       */
      const gsapScaleIn = trigger.querySelectorAll(".js-gsap-scale-in");
      if (gsapScaleIn) {
        gsapScaleIn.forEach((element, index) => {
          gsap.fromTo(
            element,
            {
              scale: 0.95,
              opacity: 0,
            },
            {
              scale: 1,
              opacity: 1,
              duration: 0.8,
              ease: "power1.in",
              scrollTrigger: element,
              delay: index * 0.1, // Adjust the delay for stagger effect
              transformOrigin: "center center",
            }
          );
        });
      }

      /**
       * Image reveal animation left
       */
      const gsapImageRevealLeft = trigger.querySelectorAll('.js-gsap-image-reveal-left');
      if (gsapImageRevealLeft) {
        gsapImageRevealLeft.forEach((element) => {
          gsap.fromTo(
            element,
            {
              clipPath: "inset(0 100% 0 0)",
            },
            {
              clipPath: "inset(0 0% 0 0)",
              duration: 0.8,
              ease: "Quint.easeIn",
              scrollTrigger: element,
            }
          );
        });
      }

      /**
       * Image reveal animation right
       */
      const gsapImageRevealRight = trigger.querySelectorAll('.js-gsap-image-reveal-right');
      if (gsapImageRevealRight) {
        gsapImageRevealRight.forEach((element) => {
          gsap.fromTo(
            element,
            {
              clipPath: "inset(0 0 0 100%)",
            },
            {
              clipPath: "inset(0 0 0 0%)",
              duration: 0.8,
              ease: "Quint.easeIn",
              scrollTrigger: element,
            }
          );
        });
      }

      /**
       * Swing in animation
       */
      const gsapSwingIn = trigger.querySelectorAll(".js-gsap-swing-in");
      if (gsapSwingIn) {
        gsapSwingIn.forEach((element, index) => {
          // Create a GSAP timeline for the animation
          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

          // Set initial properties of the element
          gsap.set(element, { opacity: 0, rotation: 0 });

          // Define the animation sequence
          tl.to(element, {
            opacity: 1,
            duration: 0.6,
            rotation: -2,
            ease: 'power2.in',
            delay: index * 0.4,
          }).to(element, {
            rotation: 2,
            duration: 0.8,
            ease: 'power2.inOut',
          }).to(element, {
            rotation: 0,
            duration: 0.6,
            ease: 'power2.out',
          });

          // Use ScrollTrigger to trigger the animation
          ScrollTrigger.create({
            trigger: element,
            start: 'top 80%',
            animation: tl,
            toggleActions: 'play none none none',
          });
        });
      }

      /**
       * Number animation
       */
      const gsapCounter = trigger.querySelectorAll(".js-gsap-number-counter");
      const counter = { value: 0 }; // Object to hold the animating value
      if (gsapCounter) {
        gsapCounter.forEach((element) => {
          const maxNumber = parseInt(element.textContent, 10); // Parse the number from the div
          gsap.to(counter, {
              value: maxNumber,
              duration: 2, // Duration of the animation
              ease: 'none', // Type of easing (can be adjusted)
              scrollTrigger: {
                trigger: element, // Element to trigger the animation
                start: 'top center', // When the element enters the viewport
                toggleActions: 'play none none none', // Play animation once when the trigger is hit
              },
              onUpdate: () => {
                element.textContent = Math.round(counter.value);
              },
          });
        });
      }

      /**
       * Horizontal scroll
       */
      const gsapHorizontalSlider = trigger.querySelectorAll(".c-grid--slider .c-posts");
      if (gsapHorizontalSlider.length) {
        gsapHorizontalSlider.forEach((element) => {
          const totalWidth = element.scrollWidth - element.offsetWidth;
          gsap.to(element, {
            x: -totalWidth, // Move the container to the left
            ease: "none",
            scrollTrigger: {
              trigger: element,
              scrub: 1,
              start: "bottom bottom-=64px",
              end: () => "+=" + totalWidth,
            },
          });
        });
      }

      /**
       * Image parallax effect
       */
      const parallaxImages = trigger.querySelectorAll('.gsap-parallax');
      if (parallaxImages.length) {
        parallaxImages.forEach((image) => {
          const imageWrapper = image.closest('picture');
          if (!imageWrapper) return;

          gsap.set(imageWrapper, {
            yPercent: -50,  // Start the image centered vertically
            y: 0,
            scale: 1.5,  // Slightly larger scale to allow for movement without showing edges
          });

          gsap.to(imageWrapper, {
            yPercent: 50,  // End with the image 50% below its starting position
            ease: "none",
            scrollTrigger: {
              trigger: imageWrapper,
              start: "center center",
              end: "bottom top",    // End when the bottom of the image leaves the top of the viewport
              scrub: true,          // Smooth scrubbing effect
              invalidateOnRefresh: true,  // Recalculate on page resize
            },
          });
        });
      }

       /**
       * Split media content scroll slider
       */
       const gsapSplitMediaContent = document.querySelectorAll('.c-split-media-content--carousel .c-card');
       if (gsapSplitMediaContent) {
         gsapSplitMediaContent.forEach((item) => {
           const carousel = item.closest('section');
          //  gsap.to(item, {
          //    scrollTrigger: {
          //      start: "top center",
          //      end: "+=100",
          //      trigger: item,
          //      onEnter: () => activateItem(item, carousel),
          //      onLeave: () => activateItem(item, carousel),
          //      onEnterBack: () => activateItem(item, carousel),
          //      onLeaveBack: () => activateItem(item, carousel),
          //    },
          //  });
 
           item.classList.add('has-hover');
           // Attach click event listener to each .c-card
           item.addEventListener('click', () => {
             activateItem(item, carousel);
           });
         });
 
         // eslint-disable-next-line no-inner-declarations
         function activateItem(item, carousel) {
           carousel.querySelectorAll('.c-card, .c-split-media-content__image').forEach(el => {
             el.classList.remove('is-active');
           });
           // Activate this item
           item.classList.add('is-active');
           carousel.querySelector('#'+ item.getAttribute('data-target')).classList.add('is-active');
         }
       }

      /**
       * Shrink Text
       */
      const gsapShrinkText = trigger.querySelectorAll('.js-gsap-shrink-text');
      if (gsapShrinkText) {
        gsapShrinkText.forEach((element) => {
          const shrinkTl = gsap.timeline({
            scrollTrigger: {
              trigger: element,
              scrub: 1,
              pin: true,
              start: "top center",
              end: "+=500",
              ease: "power1.in",
            },
          });

          shrinkTl.to(element, {
            fontSize: "64px",
            width: "100%",
          });
        });
      }

      /**
       * Scale down animation
       */
      const gsapScaleDown = trigger.querySelectorAll(".js-gsap-scale-down");
      if (gsapScaleDown) {
        gsapScaleDown.forEach((element) => {
          const tL = gsap.timeline({
            scrollTrigger: {
              trigger: element,
              scrub: 1.5,
              start: "top center",
              end: "top",
              ease: "power1.in",
            },
          });

          tL.to(element, {
            duration: 2,
            width: "100%",
            marginLeft: 0,
            marginRight: 0,
            left: 0,
            right: 0,
          });
        });
      }
    }); // End of triggers for loop
  } // End of triggers if statement

  /**
   * Marquee animation
   */
  const gsapMarquee = document.querySelectorAll(".js-gsap-marquee");
  if (gsapMarquee.length > 0) {
    gsapMarquee.forEach((element) => {
      const containerWidth = element.parentElement.scrollWidth;
      const contentWidth = element.scrollWidth;
      // Calculate the duration of the animation based on the width difference
      const animationDuration = (containerWidth + contentWidth) / 50;
      gsap.to(element, {
        x: -contentWidth,
        duration: animationDuration,
        ease: "linear",
        repeat: -1,
      });
    });
  }

  /**
   * Custom cursor on hover
   * 1. Create the custom cursor element
   * 2. Show cursor and adjust position on mousemove only when hovering over .js-custom-hover-cursor element
   * 3. Scale up the cursor when hovering
   * 4. Return to normal size when not hovering
   * 5. Remove mousemove event listener when leaving the .js-custom-hover-cursor element
   */
  const cursorTrigger = document.querySelectorAll('.js-custom-hover-cursor');
  if (cursorTrigger && window.innerWidth > 720) {
    /* 1 */
    const cursor = document.createElement('div');
    cursor.classList.add('o-custom-cursor');
    document.body.appendChild(cursor);

    cursorTrigger.forEach(item => {
      item.addEventListener('mouseenter', () => {
        document.addEventListener('mousemove', onMouseMove); /* 2 */
        gsap.to(cursor, { duration: 0.3, scale: 1 }); /* 3 */
      });
      item.addEventListener('mouseleave', () => {
        gsap.to(cursor, { duration: 0.3, scale: 0 }); /* 4 */
        document.removeEventListener('mousemove', onMouseMove); /* 5 */
      });
    });

    // eslint-disable-next-line no-inner-declarations
    function onMouseMove(e) {
      gsap.to(cursor, { duration: 0.3, left: e.clientX, top: e.clientY });
    }
  }

  /**
   * Glide slider for the features
   */
  const feature = document.querySelectorAll('.c-feature--carousel');
  if (feature.length > 0) {
    feature.forEach((slider) => {
      let startAtVar = 0;
      const featureSlider = new Glide(slider, {
        type: 'carousel',
        startAt: startAtVar,
        perView: 1,
        gap: 0,
      });
      featureSlider.mount();

      const activeSlideCount = document.querySelector('.c-feature__carousel-count-active');
      activeSlideCount.innerText = `0${startAtVar+1}`.slice(-2);

      featureSlider.on('run.after', function() {
        activeSlideCount.innerText = `0${featureSlider.index+1}`.slice(-2);
      });
    });
  }


    /**
   * Glide slider for the Carousel
   */
    const carousel = document.querySelectorAll('.c-carousel__slider--feature');
    if (carousel.length > 0) {
      carousel.forEach((slider) => {
        const carouselSlider = new Glide(slider, {
          type: 'carousel',
          perView: 3,
          gap: 100,
          loop: true,
          focusAt: 'center',
          autoplay: 7000,
          animationDuration: 800,
          animationTimingFunc: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
          hoverpause: true,
          breakpoints: {
            1024: {
              perView: 2,
            },
            600: {
              perView: 1,
            },
          },
        });
    
        // Add custom classes to slides based on their position
        carouselSlider.on('move.after', function() {
          const slides = slider.querySelectorAll('.glide__slide');
          const activeIndex = carouselSlider.index;
          
          slides.forEach((slide, index) => {
            // Remove all position classes
            slide.classList.remove('glide__slide--active', 'glide__slide--adjacent', 'glide__slide--far');
            
            // Add appropriate class based on position relative to active slide
            if (index === activeIndex) {
              slide.classList.add('glide__slide--active');
            } else if (Math.abs(index - activeIndex) === 1 || 
                      (activeIndex === 0 && index === slides.length - 1) || 
                      (activeIndex === slides.length - 1 && index === 0)) {
              slide.classList.add('glide__slide--adjacent');
            } else {
              slide.classList.add('glide__slide--far');
            }
          });
        });
    
        carouselSlider.mount();
        
        // Trigger the move.after event once to set initial classes
        carouselSlider.on('mount.after', function() {
          carouselSlider.emit('move.after');
        });
      });
    }

    /**
   * Glide slider for the featured events slider
   */
      const featured_events = document.querySelectorAll('.c-featured-events__slider');
      if (featured_events.length > 0) {
        featured_events.forEach((slider) => {
          let startAtVar = 0;
          const featured_eventsSlider = new Glide(slider, {
            type: 'carousel',
            startAt: startAtVar,
            perView: 1,
            gap: 0,
          });
          featured_eventsSlider.mount();
    
          const activeSlideCount = document.querySelector('.c-featured-events__slider-count-active');
          activeSlideCount.innerText = `0${startAtVar+1}`.slice(-2);
    
          featured_eventsSlider.on('run.after', function() {
            activeSlideCount.innerText = `0${featured_eventsSlider.index+1}`.slice(-2);
          });
        });
      }

    /**
   * Glide slider for the Item Carousel
   */
        const itemSlider = document.querySelectorAll('.c-carousel__slider--cards');
        if (itemSlider.length > 0) {
          itemSlider.forEach((slider1) => {
            const itemSlides = new Glide(slider1, {
              type: 'slider',
              bound: true,
              perView: 3,
              gap: 30,
              rewind: true,
              peek: { before: 0, after: 100 },
              perTouch: 1,
            });
            itemSlides.mount();
          });
        }

  /**
   * Glide slider for the grid horizontal 3up layout
   */
  const gridHorizontal3up = document.querySelectorAll('.c-grid--horizontal-carousel-3up');
  if (gridHorizontal3up.length > 0) {
    gridHorizontal3up.forEach((slider) => {
      const shortcode = slider.querySelector('.search-filter-results');
      if (shortcode) {
        shortcode.setAttribute('data-glide-el', 'track');
      } else {
        slider.querySelector('.c-grid__posts').setAttribute('data-glide-el', 'track');
      }
      const gridHorizontal3upSlider = new Glide(slider, {
        type: 'slider',
        startAt: 0,
        perView: 3,
        gap: 32,
        animationDuration: 1000,
        breakpoints: {
          768: {
            perView: 2,
          },
          480: {
            perView: 1,
            gap: 8,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      });
      gridHorizontal3upSlider.mount();
    });
  }

  /**
   * Glide slider for the grid horizontal 4up layout
   */
  const gridHorizontal4up = document.querySelectorAll('.c-grid--horizontal-carousel-4up, .js-glide-4up');
  if (gridHorizontal4up.length > 0) {
    gridHorizontal4up.forEach((slider) => {
      const shortcode = slider.querySelector('.search-filter-results');
      if (shortcode) {
        shortcode.setAttribute('data-glide-el', 'track');
      } else {
        slider.querySelector('.c-grid__posts, .js-glide-posts').setAttribute('data-glide-el', 'track');
      }
      const gridHorizontal4upSlider = new Glide(slider, {
        type: 'slider',
        startAt: 0,
        perView: 4,
        gap: 32,
        animationDuration: 1000,
        breakpoints: {
          768: {
            perView: 2,
          },
          480: {
            perView: 1,
            gap: 8,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      });
      gridHorizontal4upSlider.mount();
    });
  }

  /**
   * Tabs
   * 1. Check if tab links or tab content exist
   * 2. Add a click event listener to each tab link
   * 3. Get the tab name from the clicked link's data attribute
   * 4. Update the browser's URL without reloading the page
   * 5. Remove the active state from all tab links, then add it to the clicked link
   * 6. Show the relevant tab content and hide others
   */
  const tabLinks = document.querySelectorAll('.js-tab-link');
  const tabContent = document.querySelectorAll('.js-tab-content');
  /* 1 */
  if (tabLinks.length !== 0 && tabContent.length !== 0) {
    /* 2 */
    tabLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        /* 3 */
        const tab = this.getAttribute('data-tab');
        /* 4 */
        history.pushState(null, '', `?tab=${tab}`);
        /* 5 */
        tabLinks.forEach(link => link.classList.remove('this-is-active'));
        this.classList.add('this-is-active');
        /* 6 */
        tabContent.forEach(item => {
          item.style.display = item.id === tab ? 'block' : 'none';
        });
      });
    });
  }
  
});

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);